import { useState } from "react";
import { NavLink } from "react-router-dom";

import {
  FaBars,
  FaXmark,
} from "react-icons/fa6";

export const Sidebar = () => {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { icon: "/icons/dashboard.png", label: "Dashboard", path: "/dashboard" },
    { icon: "/icons/attendance.png", label: "Attendance", path: "/attendance" },
    { icon: "/icons/earnings.png", label: "Payslips", path: "/payslips" },
    { icon: "/icons/engage.png", label: "Engage", path: "/engage" },
    { icon: "/icons/helpdesk.png", label: "Help Desk", path: "/help-desk" },
    { icon: "/icons/profile.png", label: "My Profile", path: "/my-profile" },
    { icon: "/icons/approvals.png", label: "Approvals", path: "/approvals" },
    { icon: "/icons/Asset.png", label: "company Assets", path: "/company-assets" },
    {
      icon: "/icons/company.png",
      label: "Company Policies",
      path: "/company-policies",
    },
    // { icon: "/icons/company.png", label: "TDS", path: "/tds" },
  ];

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        className="md:hidden fixed top-2 left-0 p-1 mt-2 z-50 text-[#0F1E3B] rounded-lg cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        {open ? <FaXmark size={20} /> : <FaBars size={20} />}
      </button>

      {/* Sidebar */}
      <div
        className={`
    fixed top-0 left-0 
    h-full w-[260px]
    bg-[#0F1E3B] text-[#e0e0e0] shadow-xl text-lg
    transform transition-transform duration-300 
    overflow-y-auto z-50
    ${open ? "translate-x-0" : "-translate-x-[260px]"} 
    md:translate-x-0
  `}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-3 text-xl font-bold border-b-4 border-[#0F1E3B] w-full h-16 bg-[#0F1E3B] shadow-md">
          <div className="flex items-center gap-2 ml-7">
            <img
              src="/icons/hrms-icon.png"
              alt="hrmsIcon"
              className="w-7 h-7 object-contain"
            />
            <span className="text-xl font-bold text-white">HRMS TOOL</span>
          </div>

          {/* Close button mobile */}
          <button
            className="md:hidden text-white p-2 cursor-pointer"
            onClick={() => setOpen(false)}
          >
            <FaXmark size={20} />
          </button>
        </div>

        {/* Menu */}
        <ul className="space-y-3 p-5 cursor-pointer">
          {menuItems.map((item, index) => (
            <li key={index}>
              <NavLink
                to={item.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-2 p-3 rounded-lg transition 
                ${isActive
                    ? "bg-white text-black font-semibold"
                    : "hover:bg-white hover:text-[#0F1E3B]"
                  }`
                }
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  className="w-5 h-5 object-contain"
                />
                <span className="text-base font-semibold">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
